import { FC } from 'react';

import { Avatar, AvatarProps, theme } from 'antd';

import { ChannelStatusEnum } from 'entities/Channel';

interface IChannelAvatarProps extends AvatarProps {
	name: string;
	logo: string | null;
	status?: ChannelStatusEnum;
	size?: number;
}

export const ChannelAvatar: FC<IChannelAvatarProps> = ({ name, logo, status, size = 44, ...props }) => {
	const isBlocked = status === ChannelStatusEnum.Rejected;
	const {
		token: { colorPrimary },
	} = theme.useToken();

	return (
		<Avatar
			{...props}
			size={size}
			style={{
				border: 'none',
				minWidth: size,
				filter: isBlocked ? 'grayscale(100%)' : 'none',
				backgroundColor: colorPrimary,
				fontSize: size / 2.8,
			}}
			src={logo}>
			{!logo && `${name.slice(0, 1)}${name.slice(name.length - 1)}`.toUpperCase()}
		</Avatar>
	);
};
